import _objectSpread from "@babel/runtime/helpers/objectSpread2";
// @ts-check
import React from "react";
import DefaultTrivia from "../DefaultTrivia";
import { defineTrivia } from "../defineTrivia";
import { CONTAINER_TRIVIA_BEGIN } from "../positions";

// render a Tipp trivia at the default trivia position
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
export default defineTrivia({
  getPosition: function getPosition() {
    return CONTAINER_TRIVIA_BEGIN;
  },
  /**
   *
   * @param {import("../defineTrivia").CommonTriviaProps & {
   *  showTippIndex?: boolean,
   *  content: {index: number, title: string}
   *  text: string
   * }} props
   */
  Component: function Tipp(props) {
    var className = "trivia-tipp list-group-item-invert";
    var showTippIndex = props.showTippIndex,
      _props$content = props.content,
      index = _props$content.index,
      title = _props$content.title,
      text = props.text;
    return /*#__PURE__*/_jsxs(DefaultTrivia, _objectSpread(_objectSpread({}, props), {}, {
      className: className,
      children: [showTippIndex && /*#__PURE__*/_jsxs("div", {
        className: "trivia-tipp-nr",
        children: ["Tipp Nr. ", index + 1]
      }), /*#__PURE__*/_jsx("div", {
        className: "trivia-tipp-title text-xl",
        children: text
      }), /*#__PURE__*/_jsx("div", {
        className: "trivia-tipp-subtitle",
        children: title
      })]
    }));
  }
});
//# sourceMappingURL=Tipp.js.map